<!--
 * @Description: 
 * @Author: xuxiaofei
 * @Date: 2021-11-19 10:58:10
 * @LastEditors: 许晓飞 xuxiaofei.xxffe@sunyur.com
 * @LastEditTime: 2022-09-01 15:09:34
-->
<template>
  <div class="dis-flex">
    <template v-if="imgList.length">
      <template v-for="(item, index) in imgList">
        <div v-if="!item.fail" :key="item.url + index" class="showImg">
          <img :src="item.url | imgHost" alt="" class="img" />
          <div v-show="!disabled" class="removeImg" @click.stop.prevent="handleRemoveUploadImg(index)">
            <i class="iconfont" v-html="'&#xe630;'"></i>
          </div>
        </div>
      </template>
    </template>
    <sy-uploads
      v-show="itemInfo.maxFileCount > imgList.length"
      class="imageUpload"
      :action="Api.uploadApi.url"
      ref="uploadLogo"
      list-type="picture-card"
      name="file"
      :showFileList="false"
      :multiple="true"
      acceptType="IMAGE"
      :fileList="copyImgList"
      :limit="itemInfo.maxFileCount"
      :on-exceed="() => onExceed(itemInfo.maxFileCount)"
      :before-upload="handleBeforeUpload"
      :onSuccess="handleAvatarSuccess"
      :on-error="uploadFail"
      :accept="itemInfo.fileTypeList"
      :disabled="disabled"
    >
      <div class="img-box" v-loading="loading">
        <!-- 如果没有图片 -->
        <i class="el-icon-plus"></i>
      </div>
    </sy-uploads>
  </div>
</template>
        
<script>
import SyUploads from './../../../../../basis/sy-upload/upload.vue'
import i18n from './../i18n.js'
import Api from './../api'
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'CustomTable',
  components: {
    SyUploads
  },
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    itemInfo: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      pageText,
      Api
    }
  },
  computed: {
    copyImgList () {
      return JSON.parse(JSON.stringify(this.imgList))
    }
  },
  methods: {
    variableReplace: window.fe.variableReplace,
    // 上传图片成功
    handleAvatarSuccess (res, file, fileList) {
      let imgListLength = this.imgList.length
      if (fileList.length > imgListLength) {
        fileList.forEach((ele, index) => {
          if (index + 1 > imgListLength) {
            this.imgList.push({ ...ele, fail: true })
          }
        })
      }
      let len = this.imgList.length
      while (len > 0) {
        let item = this.imgList[len - 1]
        if (item.name === file.name) {
          res.success && (item.url = res.content.url)
          item.fail = false
          len = 0
        }
        len--
      }
      this.loading = false
    },
    // 上传时改为loading状态
    handleBeforeUpload (file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error(this.variableReplace(this.pageText.imageSizeLimit, {n: 5}))
        return false
      } else {
        this.loading = true
        return true
      }
    },
    // 上传失败
    uploadFail (response, file, fileList) {
      this.$message.error(response.errorMessage || this.pageText.uploadError)
      this.loading = false
    },
    onExceed (limitLength) {
      // console.log(limitLength)
      // this.$message.warning('最多只允许上传5张图片，已上传' + this.picList.length + '张，还能再上传' + 0 + '张')
      // this.$message.warning(this.variableReplace(this.pageText.imageUploadingRules, {m: limitLength, n: limitLength, s: 0}))
    },
    handleRemoveUploadImg (index) {
      console.log(index)
      this.imgList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.dis-flex {
  // display: flex;
  // display: -webkit-flex;
}
/* 图片上传 */
.imageUpload {
  display: inline;
  ::v-deep .el-upload--picture-card {
    width: 80px;
    height: 80px;
    .uploadImg-addbtn {
      width: 80px;
      height: 80px;
      .el-loading-spinner {
        height: 80px;
        line-height: 80px;
        top: 47%;
        i.el-icon-loading {
          font-size: 18px;
        }
      }
      span {
        color: #999;
        &:first-child {
          width: 25px;
          height: 25px;
          position: absolute;
          left: 27px;
          top: 17px;
          b {
            width: 3px;
            height: 100%;
            background: #999;
            position: absolute;
            left: 11px;
            top: 0;
            &:last-child {
              width: 100%;
              height: 3px;
              top: 11px;
              left: 0;
            }
          }
        }
        &:last-child {
          position: relative;
          top: -15px;
        }
      }
    }
  }
  .img-box{
    width: 80px;
    height: 80px;
    overflow: hidden;
    line-height: 80px;
    .el-icon-plus{
      font-size: 24px;
      color: #D0D0D0;
    }
  }
}
// .img-wrap{
//   height: 80px;
// }
.showImg {
  width: 80px;
  height: 80px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  // float: left;
  margin-right: 4px;
  >img {
    width: 100%;
    height: 100%;
    display: block;
  }
  &:hover {
    .removeImg {visibility: visible;}
  }
  .removeImg {
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    left: 0;
    top: 0;
    width: 80px;
    height: 80px;
    text-align: center;
    font-size: 12px;
    visibility: hidden;
    line-height: 45px;
    i.iconfont {
      position: relative;
      top: 10px;
      color: #fff;
      cursor: pointer;
    }
    // p {
    //   line-height: 20px;
    //   color: #fefefe;
    // }
  }
}
</style>
